export default __webpack_public_path__ + "static/w1-2-14c93a2f2ecbd6efef8577cd478f441d.jpg";